import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import {Modal, ModalIDs} from "../parts/modal/modal";

export function ProcessLink(data) {
    /* This function is intended to determine what the URL should be, target and flag a modal link. 
     * parameters  
     * data = JS object of components fields 
     */

    /* to-do: Modal Link
     *  When the modal component is finished, this global helper needs updated to process modal links.
     */

    if(typeof data === 'undefined'){
        return false;
    } 

    //store data in an JS object. Default is URL linktype, which is an external/custom link
    let output = {
        url: (data.url !== undefined && data.url !== '') ? data.url : false,
        target: (data.target !== undefined && data.target) ? data.target : "",
        title: (data.title !== undefined && data.title) ? data.title : "",
        rel: (data.rel !== undefined && data.rel) ? data.rel : "",
        cssClass: (data.linktype !== undefined && data.linktype) ? data.linktype : ""
    };

    // Determine URL. All linktype variations should go here.
    switch (data.linktype) {
        case 'story':
            // Internal Link
            if (typeof data.story !== 'undefined') {
                output.url = (data.story.url !== "/") ? "/" + data.story.url : data.story.url;
                output.target = (data.story.target) ? data.story.target : "_self"
                if (data.story.url.split('/')[0] === 'modals') {
                        output.url = '#';
                        output.onclick = function(e){e.preventDefault()}
                        output.cssClass = 'story modal-target';
                        output.dataFancybox = "";
                        output.modalId = data.story.uuid;
                        Fancybox.bind("[data-fancybox]", {});
                    if(!ModalIDs.includes(data.story.uuid)){
                        ModalIDs.push(data.story.uuid);
                        output.modal = Modal(data.story);
                    }
                }
            }

            break;
        case 'url':
            if(output.url !== false){
                const url = (typeof window !== 'undefined') ? new URL(window.location.href) : {};
                if ((output.url[0] === '/' && output.url[1] !== '/') || output.url.includes(url.host)) {
                    break;
                }
 
                //If External Link is not itself, open in a new tab
                if(output.url !== '#'){ 
                    output.target = '_blank'
                }
            }
            break;
        case 'email':
            if(output.url !== false){
                output.url = "mailto:" + data.url;
            }
            break;
        default:
            // URL && asset
            ;
    } 
    //Return an object that contains URL, Target, Classes and a way to flag that a modal component needs to be included. 
    return (output);
}

export function getCookie(name) {    
    if (typeof window == 'undefined' || !name) {
        return;
    }
    var cookie = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");  

    //return cookie and parse json to js object
    return cookie ? JSON.parse( cookie.pop() ) : false;
}

export function setCookie(data) { 
    if (typeof window == 'undefined') {
        return;
    }

    //If data isn't included or name isn't set in cookie params, kill function.
    if(data === undefined || !data.cookie_name) {
        return false
    }

    //Set Expiration date
    //data.cookie_expire field is days, so take days * seconds in a day.
    //Default is 30 days.
    var expirationTime = (data.cookie_expire) ? parseInt(data.cookie_expire) * 86400 : 2592000;  
    expirationTime = expirationTime * 1000; // Converts expirationtime to milliseconds
    var date = new Date(); 
    var dateTimeNow = date.getTime(); 
    date.setTime(dateTimeNow + expirationTime); // Sets date time (Time now + expiration time)
    date = date.toUTCString(); // Converts milliseconds to UTC time string
    
    //Set Cookie
    document.cookie = data.cookie_name +"="+ JSON.stringify(data) +"; SameSite=None; Secure; expires="+ date +"; path=/;"; 
}

export const getExcerpt = ({content, field_component}) => {
    const MAXLEN = 150;
    let excerpt = ''

    switch (field_component) {
        case "zignal_news":
        case "powered_by_zignal":
        case 'resources': excerpt = extractTextFromBlok([{component: 'text', text_content: content.intro_text}], MAXLEN); break;
        case 'page': excerpt = extractTextFromBlok(content.sections, MAXLEN); break;
        default:
    }

    // Remove whitespaces.
    excerpt = excerpt.trim();

    return truncateText(excerpt, MAXLEN);
}

const truncateText = (string, maxLength = false) => {
    if (maxLength && string.length >= maxLength) {
        string = string.substring(0, maxLength);
        const lastSpaceIndex = string.lastIndexOf(' ');
        if (lastSpaceIndex !== -1) {
            string = string.substring(0, lastSpaceIndex);
        }
        string += '...'
    }
    return string;
}

const extractTextFromBlok = (bloks, maxLength = false) => {
    let text = '';
    bloks?.forEach(blok => {
        if (maxLength && text.length >= maxLength) {
            return;
        }
        switch (blok.component) {
            case 'page_title': text += blok.value_prop + ' '; break;
            case 'grid':
                text += extractTextFromBlok(blok.before_content);
                text += extractTextFromBlok(blok.grid_items.map(g => g.grid_content).flat());
                text += extractTextFromBlok(blok.after_content);
                break;
            case 'flex_columns':
                text += extractTextFromBlok(blok.before_content);
                text += extractTextFromBlok(blok.columns.map(g => g.column_content).flat());
                text += extractTextFromBlok(blok.after_content);
                break;
            case 'standard':
                text += extractTextFromBlok(blok.before_content);
                text += extractTextFromBlok(blok.content_blocks);
                text += extractTextFromBlok(blok.after_content);
                break;
            case 'scroller':
                text += blok.scroller_sections.map(section => {
                    section.component = 'text';
                    return extractTextFromBlok(section);
                }).join(' ') + ' ';
                break;
            case 'news_query':
            case 'powered_by_zignal_query':
            case 'partner_query':
            case 'team_members_query':
                text += extractTextFromBlok(blok.before_content);
                text += extractTextFromBlok(blok.after_content);
                break;
            case 'flex_columns_component':
                text += extractTextFromBlok(blok.columns.map(g => g.column_content).flat());
                break;
            case 'text':
                text += blok.text_content?.content.map(c => c.content?.map(item => item.text)).join(' ') + ' ';
                break;
            default:
        }
    });

    return text;
}